import * as types from '../../action-types';
import {getCaregiverApplicationData as initialState } from "../../initialState";

const getCaregiverApplicationData = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_CAREGIVER_APPLICATION_DATA_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_CAREGIVER_APPLICATION_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_CAREGIVER_APPLICATION_DATA_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_CAREGIVER_APPLICATION_DATA_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getCaregiverApplicationData;
